// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lexend:wght@400;600;700;800;900&family=Inter:wght@300;400;500;600;700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:wght@200..700);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bg: #ece4ed;
  --text: #0b1220;
  --muted: #5b6b83;
  --border: #d8e0eb;
  --card: #ffffff;
  --blue: #0f49bd;
  --blue2: #1a60ff;
  --shadow: 0 14px 38px rgba(15, 23, 42, 0.08);
  --brinjle: #370b3b;
}

.fo-page {
  --fo-type-heading: clamp(2.1rem, 2.9vw, 2.8rem);
  --fo-type-subheading: 1.2rem;
  --fo-type-card-heading: 1.25rem;
  --fo-type-body: 1.05rem;
  --fo-type-label: 0.9rem;
  --fo-type-cta: 1rem;
  background: var(--bg);
  color: var(--text);
  font-family: Inter, system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif;
  padding: 6.2rem 0 4rem;
}

.fo-container {
  max-width: 980px;
  margin: 0 auto;
  padding: 0 18px;
}

.fo-back-link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  text-decoration: none;
  color: #370b3b;
  font-weight: 700;
  margin-bottom: 14px;
  padding: 6px 10px;
  border-radius: 999px;
  background: rgba(55, 11, 59, 0.08);
}

.fo-back-link .material-symbols-outlined {
  font-size: 20px;
}

/* Tabs */
.fo-tabs {
  display: flex;
  gap: 24px;
  border-bottom: 1px solid var(--border);
  padding-bottom: 14px;
  margin-bottom: 22px;
}

.fo-tab {
  text-decoration: none;
  color: #3d5a86;
  font-weight: 600;
  font-size: var(--fo-type-label);
  padding: 6px 6px 12px;
  position: relative;
}

.fo-tab.is-active {
  color: var(--blue);
}

.fo-tab.is-active::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: -15px;
  height: 3px;
  border-radius: 999px;
  background: var(--blue);
}

/* Hero */
.fo-hero {
  position: relative;
  border-radius: 18px;
  overflow: hidden;
  min-height: 300px;
  box-shadow: 0 28px 65px rgba(15, 23, 42, 0.25);
  background-image:
    url('https://lh3.googleusercontent.com/aida-public/AB6AXuC5FOnS3GW3poPgQwA1E8VaV5QtBRV-HXCaFkGDv5EMQa56mLLtFErqCFJbsMeqNkCUxkSIaUOEDEkkjgSLwz2Era8QYPutRbKq_t06RDTfIc0-CenK_pe7fsjI_IJ5TScWXFliSfk9vlcVtGvLRoWPZP4gpBYI6YnTNXicWJH8rOGua6W3axnEwxxdW7GDeg3ElxTZVGzb3rNLkccbdMMjKs_pZLJo_x1JFT5GlhfOsJLeoPBMrBxboXwEejZf7jrIZ2iRz4v3Bi4-');
  background-size: cover;
  background-position: center right;
}

.fo-hero--olympiad {
  background-position: center;
}

.fo-hero__overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(90deg, rgba(7, 12, 24, 0.88) 0%, rgba(7, 12, 24, 0.55) 55%, rgba(7, 12, 24, 0.18) 100%);
}

.fo-hero__content {
  position: relative;
  z-index: 2;
  padding: 44px 40px;
  max-width: 640px;
}

.fo-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: var(--fo-type-label);
  letter-spacing: 0.08em;
  color: rgba(255, 255, 255, 0.9);
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.2);
  padding: 6px 12px;
  border-radius: 999px;
  font-weight: 700;
}

.fo-hero__title {
  margin: 14px 0 10px;
  font-family: Lexend, Inter, system-ui, sans-serif;
  font-weight: 900;
  color: #fff;
  line-height: 1.05;
  font-size: var(--fo-type-heading);
  text-shadow: 0 8px 22px rgba(0,0,0,0.35);
}

.fo-hero__subtitle {
  margin: 0 0 18px;
  color: rgba(255, 255, 255, 0.86);
  line-height: 1.55;
  max-width: 520px;
  font-size: var(--fo-type-body);
}

.fo-safalta-text {
  margin: 0 0 14px;
  color: #f59e0b;
  font-size: 1.2rem;
  line-height: 1.5;
  font-weight: 700;
  max-width: 620px;
}

.fo-hero__actions {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

/* Buttons */
.fo-btn {
  border: none;
  outline: none;
  cursor: pointer;
  border-radius: 10px;
  padding: 12px 16px;
  font-weight: 700;
  font-size: var(--fo-type-cta);
  transition: transform 0.15s ease, filter 0.15s ease;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.fo-btn:hover { transform: translateY(-1px); filter: brightness(1.02); }

.fo-btn--primary {
  background: linear-gradient(180deg, var(--brinjle));
  color: #fff;
  box-shadow: 0 10px 20px rgba(38, 3, 35, 0.28);
  border: 1px solid var(--brinjle);
}

.fo-btn--secondary {
  background: rgba(255,255,255,0.12);
  color: #fff;
  border: 1px solid rgba(255,255,255,0.28);
}

.fo-btn--primary:hover,
.fo-btn--secondary:hover {
  color: #f59e0b;
  filter: none;
}

.fo-btn--ghost:hover {
  color: #f59e0b;
  filter: none;
}

.fo-btn--ghost {
  background: transparent;
  color: #370b3b;
  border: 1px solid #370b3b;
}

/* Sections */
.fo-section {
  margin-top: 26px;
}

.fo-section--spaced {
  margin-top: 34px;
}

.fo-section__title {
  margin: 0 0 14px;
  font-size: var(--fo-type-heading);
  font-weight: 800;
  color: #370b3b;
}

.fo-section__subtitle {
  margin: 6px 0 0;
  color: #370b3b;
  font-size: var(--fo-type-subheading);
  line-height: 1.5;
}

.fo-section__head {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 16px;
  flex-wrap: wrap;
}

.fo-link {
  border: none;
  background: transparent;
  color: var(--blue);
  font-weight: 700;
  cursor: pointer;
  padding: 8px 0;
  font-size: var(--fo-type-body);
}

/* Grids */
.fo-grid {
  display: grid;
  gap: 18px;
}

.fo-grid--3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.fo-grid--2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

/* Highlight cards */
.fo-card {
  background: #d6c3d9;
  border: 2px solid #370b3b;;
  border-radius: 12px;
  padding: 15px;
  box-shadow: 0 10px 22px rgba(15, 23, 42, 0.04);
}

.fo-card__icon {
  width: 45px;
  height: 45px;
  border-radius: 999px;
  display: grid;
  place-items: center;
  background: #eef3ff;
  color: #370b3b;
  margin-bottom: 10px;
}

.fo-card__title {
  margin: 0 0 6px;
  font-size: var(--fo-type-card-heading);
  font-weight: 800;
  color: #370b3b;

}

.fo-card__text {
  margin: 0;
  color: #370b3b;
  font-size: var(--fo-type-body);
  line-height: 1.5;
}

/* Accordion */
.fo-accordion {
  margin-top: 14px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.fo-accordion__item {
  background: #d6c3d9;
  border: 1px solid #370b3b;
  border-radius: 10px;
  overflow: hidden;
}

.fo-accordion__summary {
  list-style: none;
  cursor: pointer;
  padding: 14px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 800;
  font-size: var(--fo-type-body);
}

.fo-accordion__summary::-webkit-details-marker { display: none; }

.fo-accordion__left {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  color: #0b1220;
}

.fo-accordion__chev {
  color: #2b3a55;
  transition: transform 0.18s ease;
}

details[open] .fo-accordion__chev {
  transform: rotate(180deg);
}

.fo-accordion__body {
  padding: 0 16px 14px;
  color: #370b3b;
  font-size: var(--fo-type-body);
  line-height: 1.5;
}

/* Note banner */
.fo-note {
  margin-top: 14px;
  background: #eef6ff;
  border: 1px solid #d6e8ff;
  border-radius: 10px;
  padding: 12px 14px;
  display: flex;
  gap: 10px;
  align-items: flex-start;
  color: #1a4dbd;
  font-size: var(--fo-type-body);
  line-height: 1.5;
}

/* Advantage cards */
.fo-adv {
  background: #d6c3d9;
  border: 1px solid #370b3b;
  border-radius: 12px;
  padding: 16px;
  display: flex;
  gap: 12px;
  box-shadow: 0 10px 22px rgba(15, 23, 42, 0.04);
}

.fo-adv__icon {
  width: 60px;
  height: 45px;
  border-radius: 10px;
  display: grid;
  place-items: center;
  background: #ffffff;
  color: #370b3b;
}

.fo-adv__title {
  margin: 0;
  font-size: var(--fo-type-card-heading);
  font-weight: 800;
}

.fo-adv__text {
  margin: 6px 0 0;
  font-size: var(--fo-type-body);
  color: #370b3b;
  line-height: 1.45;
}

/* CTA */
.fo-cta {
  margin-top: 34px;
  border-radius: 16px;
  padding: 22px 22px;
  color: #fff;
  background:#d6c3d9;
  box-shadow: 0 26px 60px rgba(15, 23, 42, 0.35);
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.fo-cta__title {
  margin: 0 0 6px;
  font-family: Lexend, Inter, system-ui, sans-serif;
  font-weight: 900;
  letter-spacing: 0.01em;
  font-size: var(--fo-type-subheading);
  color:#370b3b;
}

.fo-cta__text {
  margin: 0;
  color: #370b3b;
  font-size: var(--fo-type-body);
  max-width: 420px;
  line-height: 1.45;
}

.fo-cta__actions {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

/* Responsive */
@media (max-width: 920px) {
  .fo-grid--3 { grid-template-columns: 1fr; }
  .fo-grid--2 { grid-template-columns: 1fr; }
  .fo-hero__content { padding: 34px 22px; }
}

@media (max-width: 520px) {
  .fo-tabs { gap: 14px; }
  .fo-tab { font-size: 0.95rem; }
}

html[data-theme="dark"] .foundation-page {
  background: #02030a;
  color: #f8fafc;
}

html[data-theme="dark"] .fo-hero,
html[data-theme="dark"] .fo-hero__content,
html[data-theme="dark"] .fo-hero__content h1,
html[data-theme="dark"] .fo-hero__content p {
  background: #050b17;
  color: #f8fafc;
}

html[data-theme="dark"] .fo-grid--3,
html[data-theme="dark"] .fo-grid--2,
html[data-theme="dark"] .fo-cta,
html[data-theme="dark"] .fo-adv,
html[data-theme="dark"] .fo-tabs,
html[data-theme="dark"] .fo-panel {
  background: #0a1220;
  border-color: rgba(255, 255, 255, 0.08);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.45);
}

html[data-theme="dark"] .fo-card,
html[data-theme="dark"] .fo-adv__text,
html[data-theme="dark"] .fo-tab,
html[data-theme="dark"] .fo-panel summary {
  color: #e5e7eb;
}

/* .fo-hero--olympiad {
  background-image: url("public/images/what_make_unique/what_make_unique.jpeg");
  background-size: cover;
  background-position: center right;
} */

.fo-tab is-active{
  color: #370b3b 

}
`, "",{"version":3,"sources":["webpack://./src/frontend/pages/Courses/foundation-olympiad.css"],"names":[],"mappings":"AAGA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,4CAA4C;EAC5C,kBAAkB;AACpB;;AAEA;EACE,+CAA+C;EAC/C,4BAA4B;EAC5B,+BAA+B;EAC/B,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,iFAAiF;EACjF,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA;EACE,eAAe;AACjB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,SAAS;EACT,sCAAsC;EACtC,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,+BAA+B;EAC/B,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,aAAa;EACb,WAAW;EACX,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,8CAA8C;EAC9C;6UAC2U;EAC3U,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,mHAAmH;AACrH;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,+BAA+B;EAC/B,sBAAsB;EACtB,+BAA+B;EAC/B,qCAAqC;EACrC,0CAA0C;EAC1C,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,iDAAiD;EACjD,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,iCAAiC;EACjC,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA,YAAY;AACZ;EACE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,mDAAmD;EACnD,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA,gBAAgB,2BAA2B,EAAE,wBAAwB,EAAE;;AAEvE;EACE,mDAAmD;EACnD,WAAW;EACX,6CAA6C;EAC7C,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;EAClC,WAAW;EACX,wCAAwC;AAC1C;;AAEA;;EAEE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,aAAa;AACb;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,8BAA8B;AAChC;;AAEA,UAAU;AACV;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,sCAAsC;EACtC,gBAAgB;EAChB,cAAc;;AAEhB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA,iDAAiD,aAAa,EAAE;;AAEhE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,SAAS;EACT,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,cAAc;EACd,iBAAiB;AACnB;;AAEA,QAAQ;AACR;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,8CAA8C;EAC9C,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iDAAiD;EACjD,gBAAgB;EAChB,sBAAsB;EACtB,oCAAoC;EACpC,aAAa;AACf;;AAEA;EACE,SAAS;EACT,cAAc;EACd,8BAA8B;EAC9B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,cAAc,0BAA0B,EAAE;EAC1C,cAAc,0BAA0B,EAAE;EAC1C,oBAAoB,kBAAkB,EAAE;AAC1C;;AAEA;EACE,WAAW,SAAS,EAAE;EACtB,UAAU,kBAAkB,EAAE;AAChC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;;EAIE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;;;;EAME,mBAAmB;EACnB,uCAAuC;EACvC,2CAA2C;AAC7C;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;;;GAIG;;AAEH;EACE;;AAEF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Lexend:wght@400;600;700;800;900&family=Inter:wght@300;400;500;600;700&display=swap');\r\n@import url('https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:wght@200..700');\r\n\r\n:root {\r\n  --bg: #ece4ed;\r\n  --text: #0b1220;\r\n  --muted: #5b6b83;\r\n  --border: #d8e0eb;\r\n  --card: #ffffff;\r\n  --blue: #0f49bd;\r\n  --blue2: #1a60ff;\r\n  --shadow: 0 14px 38px rgba(15, 23, 42, 0.08);\r\n  --brinjle: #370b3b;\r\n}\r\n\r\n.fo-page {\r\n  --fo-type-heading: clamp(2.1rem, 2.9vw, 2.8rem);\r\n  --fo-type-subheading: 1.2rem;\r\n  --fo-type-card-heading: 1.25rem;\r\n  --fo-type-body: 1.05rem;\r\n  --fo-type-label: 0.9rem;\r\n  --fo-type-cta: 1rem;\r\n  background: var(--bg);\r\n  color: var(--text);\r\n  font-family: Inter, system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif;\r\n  padding: 6.2rem 0 4rem;\r\n}\r\n\r\n.fo-container {\r\n  max-width: 980px;\r\n  margin: 0 auto;\r\n  padding: 0 18px;\r\n}\r\n\r\n.fo-back-link {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  text-decoration: none;\r\n  color: #370b3b;\r\n  font-weight: 700;\r\n  margin-bottom: 14px;\r\n  padding: 6px 10px;\r\n  border-radius: 999px;\r\n  background: rgba(55, 11, 59, 0.08);\r\n}\r\n\r\n.fo-back-link .material-symbols-outlined {\r\n  font-size: 20px;\r\n}\r\n\r\n/* Tabs */\r\n.fo-tabs {\r\n  display: flex;\r\n  gap: 24px;\r\n  border-bottom: 1px solid var(--border);\r\n  padding-bottom: 14px;\r\n  margin-bottom: 22px;\r\n}\r\n\r\n.fo-tab {\r\n  text-decoration: none;\r\n  color: #3d5a86;\r\n  font-weight: 600;\r\n  font-size: var(--fo-type-label);\r\n  padding: 6px 6px 12px;\r\n  position: relative;\r\n}\r\n\r\n.fo-tab.is-active {\r\n  color: var(--blue);\r\n}\r\n\r\n.fo-tab.is-active::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: -15px;\r\n  height: 3px;\r\n  border-radius: 999px;\r\n  background: var(--blue);\r\n}\r\n\r\n/* Hero */\r\n.fo-hero {\r\n  position: relative;\r\n  border-radius: 18px;\r\n  overflow: hidden;\r\n  min-height: 300px;\r\n  box-shadow: 0 28px 65px rgba(15, 23, 42, 0.25);\r\n  background-image:\r\n    url('https://lh3.googleusercontent.com/aida-public/AB6AXuC5FOnS3GW3poPgQwA1E8VaV5QtBRV-HXCaFkGDv5EMQa56mLLtFErqCFJbsMeqNkCUxkSIaUOEDEkkjgSLwz2Era8QYPutRbKq_t06RDTfIc0-CenK_pe7fsjI_IJ5TScWXFliSfk9vlcVtGvLRoWPZP4gpBYI6YnTNXicWJH8rOGua6W3axnEwxxdW7GDeg3ElxTZVGzb3rNLkccbdMMjKs_pZLJo_x1JFT5GlhfOsJLeoPBMrBxboXwEejZf7jrIZ2iRz4v3Bi4-');\r\n  background-size: cover;\r\n  background-position: center right;\r\n}\r\n\r\n.fo-hero--olympiad {\r\n  background-position: center;\r\n}\r\n\r\n.fo-hero__overlay {\r\n  position: absolute;\r\n  inset: 0;\r\n  background: linear-gradient(90deg, rgba(7, 12, 24, 0.88) 0%, rgba(7, 12, 24, 0.55) 55%, rgba(7, 12, 24, 0.18) 100%);\r\n}\r\n\r\n.fo-hero__content {\r\n  position: relative;\r\n  z-index: 2;\r\n  padding: 44px 40px;\r\n  max-width: 640px;\r\n}\r\n\r\n.fo-badge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  font-size: var(--fo-type-label);\r\n  letter-spacing: 0.08em;\r\n  color: rgba(255, 255, 255, 0.9);\r\n  background: rgba(255, 255, 255, 0.12);\r\n  border: 1px solid rgba(255, 255, 255, 0.2);\r\n  padding: 6px 12px;\r\n  border-radius: 999px;\r\n  font-weight: 700;\r\n}\r\n\r\n.fo-hero__title {\r\n  margin: 14px 0 10px;\r\n  font-family: Lexend, Inter, system-ui, sans-serif;\r\n  font-weight: 900;\r\n  color: #fff;\r\n  line-height: 1.05;\r\n  font-size: var(--fo-type-heading);\r\n  text-shadow: 0 8px 22px rgba(0,0,0,0.35);\r\n}\r\n\r\n.fo-hero__subtitle {\r\n  margin: 0 0 18px;\r\n  color: rgba(255, 255, 255, 0.86);\r\n  line-height: 1.55;\r\n  max-width: 520px;\r\n  font-size: var(--fo-type-body);\r\n}\r\n\r\n.fo-safalta-text {\r\n  margin: 0 0 14px;\r\n  color: #f59e0b;\r\n  font-size: 1.2rem;\r\n  line-height: 1.5;\r\n  font-weight: 700;\r\n  max-width: 620px;\r\n}\r\n\r\n.fo-hero__actions {\r\n  display: flex;\r\n  gap: 12px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n/* Buttons */\r\n.fo-btn {\r\n  border: none;\r\n  outline: none;\r\n  cursor: pointer;\r\n  border-radius: 10px;\r\n  padding: 12px 16px;\r\n  font-weight: 700;\r\n  font-size: var(--fo-type-cta);\r\n  transition: transform 0.15s ease, filter 0.15s ease;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.fo-btn:hover { transform: translateY(-1px); filter: brightness(1.02); }\r\n\r\n.fo-btn--primary {\r\n  background: linear-gradient(180deg, var(--brinjle));\r\n  color: #fff;\r\n  box-shadow: 0 10px 20px rgba(38, 3, 35, 0.28);\r\n  border: 1px solid var(--brinjle);\r\n}\r\n\r\n.fo-btn--secondary {\r\n  background: rgba(255,255,255,0.12);\r\n  color: #fff;\r\n  border: 1px solid rgba(255,255,255,0.28);\r\n}\r\n\r\n.fo-btn--primary:hover,\r\n.fo-btn--secondary:hover {\r\n  color: #f59e0b;\r\n  filter: none;\r\n}\r\n\r\n.fo-btn--ghost:hover {\r\n  color: #f59e0b;\r\n  filter: none;\r\n}\r\n\r\n.fo-btn--ghost {\r\n  background: transparent;\r\n  color: #370b3b;\r\n  border: 1px solid #370b3b;\r\n}\r\n\r\n/* Sections */\r\n.fo-section {\r\n  margin-top: 26px;\r\n}\r\n\r\n.fo-section--spaced {\r\n  margin-top: 34px;\r\n}\r\n\r\n.fo-section__title {\r\n  margin: 0 0 14px;\r\n  font-size: var(--fo-type-heading);\r\n  font-weight: 800;\r\n  color: #370b3b;\r\n}\r\n\r\n.fo-section__subtitle {\r\n  margin: 6px 0 0;\r\n  color: #370b3b;\r\n  font-size: var(--fo-type-subheading);\r\n  line-height: 1.5;\r\n}\r\n\r\n.fo-section__head {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: flex-end;\r\n  gap: 16px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.fo-link {\r\n  border: none;\r\n  background: transparent;\r\n  color: var(--blue);\r\n  font-weight: 700;\r\n  cursor: pointer;\r\n  padding: 8px 0;\r\n  font-size: var(--fo-type-body);\r\n}\r\n\r\n/* Grids */\r\n.fo-grid {\r\n  display: grid;\r\n  gap: 18px;\r\n}\r\n\r\n.fo-grid--3 {\r\n  grid-template-columns: repeat(3, minmax(0, 1fr));\r\n}\r\n\r\n.fo-grid--2 {\r\n  grid-template-columns: repeat(2, minmax(0, 1fr));\r\n}\r\n\r\n/* Highlight cards */\r\n.fo-card {\r\n  background: #d6c3d9;\r\n  border: 2px solid #370b3b;;\r\n  border-radius: 12px;\r\n  padding: 15px;\r\n  box-shadow: 0 10px 22px rgba(15, 23, 42, 0.04);\r\n}\r\n\r\n.fo-card__icon {\r\n  width: 45px;\r\n  height: 45px;\r\n  border-radius: 999px;\r\n  display: grid;\r\n  place-items: center;\r\n  background: #eef3ff;\r\n  color: #370b3b;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.fo-card__title {\r\n  margin: 0 0 6px;\r\n  font-size: var(--fo-type-card-heading);\r\n  font-weight: 800;\r\n  color: #370b3b;\r\n\r\n}\r\n\r\n.fo-card__text {\r\n  margin: 0;\r\n  color: #370b3b;\r\n  font-size: var(--fo-type-body);\r\n  line-height: 1.5;\r\n}\r\n\r\n/* Accordion */\r\n.fo-accordion {\r\n  margin-top: 14px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n}\r\n\r\n.fo-accordion__item {\r\n  background: #d6c3d9;\r\n  border: 1px solid #370b3b;\r\n  border-radius: 10px;\r\n  overflow: hidden;\r\n}\r\n\r\n.fo-accordion__summary {\r\n  list-style: none;\r\n  cursor: pointer;\r\n  padding: 14px 16px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  font-weight: 800;\r\n  font-size: var(--fo-type-body);\r\n}\r\n\r\n.fo-accordion__summary::-webkit-details-marker { display: none; }\r\n\r\n.fo-accordion__left {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  color: #0b1220;\r\n}\r\n\r\n.fo-accordion__chev {\r\n  color: #2b3a55;\r\n  transition: transform 0.18s ease;\r\n}\r\n\r\ndetails[open] .fo-accordion__chev {\r\n  transform: rotate(180deg);\r\n}\r\n\r\n.fo-accordion__body {\r\n  padding: 0 16px 14px;\r\n  color: #370b3b;\r\n  font-size: var(--fo-type-body);\r\n  line-height: 1.5;\r\n}\r\n\r\n/* Note banner */\r\n.fo-note {\r\n  margin-top: 14px;\r\n  background: #eef6ff;\r\n  border: 1px solid #d6e8ff;\r\n  border-radius: 10px;\r\n  padding: 12px 14px;\r\n  display: flex;\r\n  gap: 10px;\r\n  align-items: flex-start;\r\n  color: #1a4dbd;\r\n  font-size: var(--fo-type-body);\r\n  line-height: 1.5;\r\n}\r\n\r\n/* Advantage cards */\r\n.fo-adv {\r\n  background: #d6c3d9;\r\n  border: 1px solid #370b3b;\r\n  border-radius: 12px;\r\n  padding: 16px;\r\n  display: flex;\r\n  gap: 12px;\r\n  box-shadow: 0 10px 22px rgba(15, 23, 42, 0.04);\r\n}\r\n\r\n.fo-adv__icon {\r\n  width: 60px;\r\n  height: 45px;\r\n  border-radius: 10px;\r\n  display: grid;\r\n  place-items: center;\r\n  background: #ffffff;\r\n  color: #370b3b;\r\n}\r\n\r\n.fo-adv__title {\r\n  margin: 0;\r\n  font-size: var(--fo-type-card-heading);\r\n  font-weight: 800;\r\n}\r\n\r\n.fo-adv__text {\r\n  margin: 6px 0 0;\r\n  font-size: var(--fo-type-body);\r\n  color: #370b3b;\r\n  line-height: 1.45;\r\n}\r\n\r\n/* CTA */\r\n.fo-cta {\r\n  margin-top: 34px;\r\n  border-radius: 16px;\r\n  padding: 22px 22px;\r\n  color: #fff;\r\n  background:#d6c3d9;\r\n  box-shadow: 0 26px 60px rgba(15, 23, 42, 0.35);\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  gap: 16px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.fo-cta__title {\r\n  margin: 0 0 6px;\r\n  font-family: Lexend, Inter, system-ui, sans-serif;\r\n  font-weight: 900;\r\n  letter-spacing: 0.01em;\r\n  font-size: var(--fo-type-subheading);\r\n  color:#370b3b;\r\n}\r\n\r\n.fo-cta__text {\r\n  margin: 0;\r\n  color: #370b3b;\r\n  font-size: var(--fo-type-body);\r\n  max-width: 420px;\r\n  line-height: 1.45;\r\n}\r\n\r\n.fo-cta__actions {\r\n  display: flex;\r\n  gap: 12px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n/* Responsive */\r\n@media (max-width: 920px) {\r\n  .fo-grid--3 { grid-template-columns: 1fr; }\r\n  .fo-grid--2 { grid-template-columns: 1fr; }\r\n  .fo-hero__content { padding: 34px 22px; }\r\n}\r\n\r\n@media (max-width: 520px) {\r\n  .fo-tabs { gap: 14px; }\r\n  .fo-tab { font-size: 0.95rem; }\r\n}\r\n\r\nhtml[data-theme=\"dark\"] .foundation-page {\r\n  background: #02030a;\r\n  color: #f8fafc;\r\n}\r\n\r\nhtml[data-theme=\"dark\"] .fo-hero,\r\nhtml[data-theme=\"dark\"] .fo-hero__content,\r\nhtml[data-theme=\"dark\"] .fo-hero__content h1,\r\nhtml[data-theme=\"dark\"] .fo-hero__content p {\r\n  background: #050b17;\r\n  color: #f8fafc;\r\n}\r\n\r\nhtml[data-theme=\"dark\"] .fo-grid--3,\r\nhtml[data-theme=\"dark\"] .fo-grid--2,\r\nhtml[data-theme=\"dark\"] .fo-cta,\r\nhtml[data-theme=\"dark\"] .fo-adv,\r\nhtml[data-theme=\"dark\"] .fo-tabs,\r\nhtml[data-theme=\"dark\"] .fo-panel {\r\n  background: #0a1220;\r\n  border-color: rgba(255, 255, 255, 0.08);\r\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.45);\r\n}\r\n\r\nhtml[data-theme=\"dark\"] .fo-card,\r\nhtml[data-theme=\"dark\"] .fo-adv__text,\r\nhtml[data-theme=\"dark\"] .fo-tab,\r\nhtml[data-theme=\"dark\"] .fo-panel summary {\r\n  color: #e5e7eb;\r\n}\r\n\r\n/* .fo-hero--olympiad {\r\n  background-image: url(\"public/images/what_make_unique/what_make_unique.jpeg\");\r\n  background-size: cover;\r\n  background-position: center right;\r\n} */\r\n\r\n.fo-tab is-active{\r\n  color: #370b3b \r\n\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
